import React from 'react';
import { UniversalJiraList } from '../../../../common/UniversalJiraList';

export const JiraAllIssuesList = ({ data }) => {
  if (!data) {
    return <p>Brak wyników dla bieżących ustawień!</p>;
  }

  return (
    <UniversalJiraList
      items={data.issues}
      config={{
        filterByMonth: false,
        getKey: (item) => item.key,
        getTitle: (item) => `${item.key}: ${item.fields.summary}`,
        getLabels: (item) => item.fields.labels,
        getLink: (item) => `https://pamprojectpl.atlassian.net/browse/${item.key}`,
        getStatus: (item) => item.fields.status.name,
        getReporterLabel: () => 'Osoba przypisana:',
        getReporter: (item) => item.fields.assignee ? item.fields.assignee.displayName : 'Brak',
        getWorklogs: (item) => item.fields.worklog.worklogs,
        getOriginalEstimate: (item) => item.fields.timetracking.originalEstimate,
        getLoggedTimeLabel: () => 'Czas zarejestrowany:',
      }}
    />
  );
};
